<template>
  <AnalyticsModuleContainer
    :title-key="config.titleKey"
    :grid-row-span="2"
    :explore-link="config.exploreLink"
    :benchmark-link="config.benchmarkLink"
    :info-content="config.infoContent"
    :member-short-titles="getMembersFromQuery(query)"
  >
    <AnalyticsExtendedQueryRenderer
      v-if="!error"
      :time-option="{ type: QueryTimeType.PERIOD }"
      :query="query"
      @hide-module="hideModule"
    >
      <template #default="{ queryResults }">
        <AnalyticsRendererTop
          :query-results="queryResults"
          :column-order="config.columnOrder"
          :column-translation-prefix="config.columnsTranslationPrefix"
        />
      </template>
    </AnalyticsExtendedQueryRenderer>
    <AnalyticsModuleErrorTemplate
      v-if="error"
      :error="error"
    />
  </AnalyticsModuleContainer>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import type { TranslationKeys } from '~/plugins/i18n'
import { getMembersFromQuery } from '~/services/analytics'
import { useAnalyticsStore } from '~/stores/analytics'
import {
  type ModuleExplorerLink,
  type ModuleInfoContent,
  type ModuleBenchmarkLink,
  QueryTimeType,
  type Filter
} from '~/types/analytics'
import type { Order } from '~/types/cube'

type TopModuleConfig = {
  titleKey: TranslationKeys
  columnOrder: string[]
  columnsTranslationPrefix: string
  exploreLink?: ModuleExplorerLink
  benchmarkLink?: ModuleBenchmarkLink
  infoContent?: ModuleInfoContent
}

type TopModuleQuery = {
  measures: [string]
  dimensions: [string, ...string[]]
  filters?: Filter[]
  order?: Order[] | undefined
  limit: number
}

export default {
  name: 'ModuleComponentsTop',
  props: {
    query: {
      type: Object as PropType<TopModuleQuery>,
      required: true
    },
    config: {
      type: Object as PropType<TopModuleConfig>,
      required: true
    }
  },
  setup() {
    return { QueryTimeType, getMembersFromQuery }
  },
  data(): { error: Error | undefined } {
    return {
      error: undefined
    }
  },
  computed: {
    ...mapState(useAnalyticsStore, ['analyticsParams'])
  },
  watch: {
    analyticsParams: {
      handler() {
        this.error = undefined
      }
    }
  },
  methods: {
    hideModule(error: any) {
      this.error = error
    }
  }
}
</script>
